module.exports = __webpack_public_path__ + "img/home (1).dc9849d1.png";